<template>
  <div class="row">
    <div class="col-md-6 mt-3">
      <vs-input
        label="Abreviación"
        maxlength="10"
        class="w-full"
        v-model="option.valor"
        data-cy="abreviation"
      />
    </div>
    <div class="col-md-6 mt-3">
      <vs-input
        label="Descripción"
        maxlength="100"
        class="w-full"
        v-model="option.descripcion"
        data-cy="description"
      />
    </div>
    <div class="col-md-12 mt-3">
      <h5>
        Esta opción puede ser usada en distintos formularios de la aplicación,
        para esto, selecciona en que listados te gustaría verlo
      </h5>
    </div>
    <div class="col-md-4 mt-3">
      <b-form-checkbox
        @change="clearNumeration"
        v-model="option.extra.uso.numeracion"
        name="uso-numeracion"
      >
        Para numeración
      </b-form-checkbox>
    </div>
    <div class="col-md-4 mt-3">
      <b-form-checkbox
        v-model="option.extra.uso.aprobaciones"
        name="uso-apr"
      >
        Para tipos de Adjuntos de aprobaciones
      </b-form-checkbox>
    </div>
    <div class="col-md-4 mt-3">
      <b-form-checkbox
        v-model="option.extra.uso.referencias"
        name="uso-referencias"
      >
        Para referencias
      </b-form-checkbox>
    </div>
    <div class="col-md-12 mt-3" v-if="option.extra.uso.numeracion">
      <h5>
        Selecciona que tipo de numeración tendrá
      </h5>
    </div>
    <div class="col-md-6 mt-3" v-if="option.extra.uso.numeracion">
      <b-form-checkbox
        id="num-int"
        name="num-int"
        @change="setNumeration('int')"
        v-model="option.extra.numInt"
      >
        Numeración interna
      </b-form-checkbox>
    </div>
    <div class="col-md-6 mt-3" v-if="option.extra.uso.numeracion">
      <b-form-checkbox
        id="num-of"
        name="num-of"
        @change="setNumeration('of')"
        v-model="option.extra.numOf"
      >
        Numeración oficial
      </b-form-checkbox>
    </div>
    <div
      class="col-md-6 mt-3"
      v-if="option.extra.uso.numeracion && type !== 'category'"
    >
      <b-form-checkbox
        id="uso-contraloria"
        name="uso-contraloria"
        @change="setManagement('control')"
        v-model="option.extra.uso.contraloria"
      >
        Va a contraloría
      </b-form-checkbox>
    </div>
    <div
      class="col-md-6 mt-3"
      v-if="option.extra.uso.numeracion && type !== 'category'"
    >
      <b-form-checkbox
        id="uso-tramite"
        name="uso-tramite"
        @change="setManagement('management')"
        v-model="option.extra.uso.tramite"
      >
        Va a trámite
      </b-form-checkbox>
    </div>
    <div class="col-md-6 mt-3" v-if="type !== 'category'">
      <label for="id-doc-digital">Código docDigital</label>
      <b-form-input
        id="id-doc-digital"
        class="w-100"
        v-model="option.extra.idDocDigital"
        data-cy="id-doc-digital"
      />
    </div>
    <div class="col-md-12 d-flex justify-content-end">
      <vs-button
        color="primary"
        class="margin-top"
        type="border"
        icon="save"
        v-on:click="saveOption()"
      >
        Guardar
      </vs-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ManageOption',
  props: {
    option: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      default: () => ''
    }
  },
  methods: {
    setNumeration(type) {
      if (type === 'int') {
        this.option.extra.numOf = false;
      }
      if (type === 'of') {
        this.option.extra.numInt = false;
      }
    },
    setManagement(type) {
      if (type === 'control') {
        this.option.extra.uso.tramite = false;
      }
      if (type === 'management') {
        this.option.extra.uso.contraloria = false;
      }
    },
    clearNumeration() {
      this.option.extra.numInt = false;
      this.option.extra.numOf = false;
    },
    saveOption() {
      this.$emit('save-option', this.option);
    }
  }
};
</script>
